import { requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const genericStringValidator = trimmedString;
export const genericStringValidatorRequired = trimmedString.required(
  requiredMessage
);
